import {css, cx} from "@panda/css";

interface IProps {
    className?: string;
}

export const Divider = (props: IProps) => {
    const {className} = props;

    return <div className={cx(dividerStyle, className)} />;
};

const dividerStyle = css({
    width: "100%",
    height: "0.1rem",
    backgroundColor: "var(--colors-gray-300)"
});
import {css, cx} from "@panda/css";

interface IProps {
    className?: string;
}

export const Divider = (props: IProps) => {
    const {className} = props;

    return <div className={cx(dividerStyle, className)} />;
};

const dividerStyle = css({
    width: "100%",
    height: "0.1rem",
    backgroundColor: "var(--colors-gray-300)"
});
